import React from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';

const ContainerDiv = styled.div`
  text-align: center;

  a {
    font-size: 14px;
    color: var(--color-grey-3);
    text-decoration: underline dotted;
  }
`;

const Legal = () => (
  <ContainerDiv>
    <Typography.Body type="Body 14">
      By signing up for FleetOps, you agree to our
    </Typography.Body>
    <br />
    <a
      href={'https://www.fleetops.com/terms-and-conditions'}
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Service
    </a>{' '}
    <Typography.Body type="Body 14">and </Typography.Body>
    <a
      href={'https://www.fleetops.com/privacy'}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>
  </ContainerDiv>
);

export default Legal;
